enum userSettingType{
    ADD_USER_SETTING_START='ADD_USER_SETTING_START',
    ADD_USER_SETTING_SUCCESS='ADD_USER_SETTING_SUCCESS',
    ADD_USER_SETTING_ERROR='ADD_USER_SETTING_ERROR',
    GET_USER_SETTING_START='GET_USER_SETTING_START',
    GET_USER_SETTING_SUCCESS='GET_USER_SETTING_SUCCESS',
    GET_USER_SETTING_ERROR='GET_USER_SETTING_ERROR',
    RESET_USER_SETTING_STATE = 'RESET_USER_SETTING_STATE',
    RESET_USER_SETTING_SUCCESS_STATE = 'RESET_USER_SETTING_SUCCESS_STATE',
    RESET_USER_SETTING_ADD_STATE = 'RESET_USER_SETTING_ADD_STATE',
    GET_DATA_RANGE_START='GET_DATA_RANGE_START',
    GET_DATA_RANGE_SUCCESS='GET_DATA_RANGE_SUCCESS',
    GET_DATA_RANGE_ERROR='GET_DATA_RANGE_ERROR',
    RESET_DATA_RANGE_STATE = 'RESET_DATA_RANGE_STATE',
    // RESET_DATA_RANGE_SUCCESS_STATE= 'RESET_DATA_RANGE_SUCCESS_STATE',
    // SET_DATA_RANGE_SUCCESS_STATE='SET_DATA_RANGE_SUCCESS_STATE',
    // RESET_COLUMN_SUCCESS_STATE='RESET_COLUMN_SUCCESS_STATE',
    // SET_COLUMN_SUCCESS_STATE='SET_COLUMN_SUCCESS_STATE'

}

export default userSettingType;